import { FormControl, FormHelperText, InputLabel, MenuItem, Select } from '@material-ui/core';
import React from 'react';
import { useStyles } from '../styles/Styles';

export default function ErrorAwareSelectField(props) {
    const classes = useStyles(props, "select")();

    const helperText = () => {
        if (props.errors && props.errors.has(props.name)) {
            return props.errors.get(props.name).huText;
        } else if (props.prevValue && props.value.value !== props.prevValue.value) {
            return props.prevValue.label;
        } else {
            return "";
        }
    }

    const isError = () => {
        if (props.errors) {
            return props.errors.has(props.name);
        } else {
            return false;
        }
    }

    return (
        <FormControl variant="outlined" required fullWidth error={isError()}>
            <InputLabel id={props.labelId}>{props.label}</InputLabel>
            <Select
                labelId={props.labelId}
                id={props.id}
                value={props.value}
                name={props.name}
                onChange={props.onChange}
                label={props.label}
                className={classes.root}
                disabled={props.disabled}>
                {props.options.map((value, index) =>
                    <MenuItem key={index} value={value}>{value.label}</MenuItem>
                )}
            </Select>
            <FormHelperText>{helperText()}</FormHelperText>
        </FormControl>
    )
};